import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSentList as _getSentList, getSentPayMonth as _getSentPayMonth, recallSent } from 'api/payroll/pay-slip';
export default {
  data: function data() {
    return {
      loading: true,
      pay_month: this.$route.query.month3 || '',
      wageLength: -1,
      wageList: [] // 方案列表
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.$route.query.month3) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this.getSentPayMonth();
          case 3:
            _context.next = 5;
            return _this.getSentList();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getSentPayMonth: function getSentPayMonth() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _res$data$;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getSentPayMonth();
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) _this2.pay_month = ((_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.child[0]) || _this2.$util.fmtDate('yyyy-MM');
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSentList: function getSentList() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (_this3.pay_month) {
                _context3.next = 3;
                break;
              }
              _this3.$message.warning(_this3.$t('payroll_salary_28'));
              return _context3.abrupt("return");
            case 3:
              // 工资条列表
              _this3.loading = true;
              _this3.$router.push({
                query: {
                  active: '3',
                  month3: _this3.pay_month
                }
              });
              _getSentList({
                pay_month: _this3.pay_month
              }).then(function (res) {
                if (res && res.code === 1) _this3.wageList = res.data;
                _this3.wageLength = res.data.length;
              }).finally(function () {
                return _this3.loading = false;
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onCancel: function onCancel(item) {
      var _this4 = this;
      // 待发子项目选择工资条
      this.$confirm(this.$t('pay_slip_32'), this.$t('pay_slip_31'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              recallSent({
                payslip_id: item.payslip_id
              }).then(function (res) {
                if (res && res.code === 1) _this4.getSentList();
                _this4.$message.success(_this4.$t('pay_slip_36'));
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))).catch(function () {});
    },
    goToDetail: function goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({
        path: '/payroll/setpay-pay-slip/' + item.payslip_id,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          payslip_scheme_id: item.id,
          type: item.settlement_type,
          tax_deduction_status: item.tax_deduction_status,
          state: state
        })
      });
    },
    sendResults: function sendResults(item) {
      this.$router.push({
        path: '/payroll/pay-send-results/' + item.payslip_id,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          payslip_scheme_id: item.id,
          type: item.settlement_type,
          tax_deduction_status: item.tax_deduction_status
        })
      });
    }
  }
};